<template>
	<div>
		<div class="banner">
			<el-carousel height="574px">
				<el-carousel-item v-for="(item,index) in pageDetail.parents_ads" :key="item">
					<img :src="imgBaseUrl + item" alt="">
				</el-carousel-item>
			</el-carousel>
		</div>
		<div class="intro_box">
			<div class="title">{{pageDetail.parents_title}}</div>
			<div class="info">{{pageDetail.parents_text}}</div>
		</div>
		<div class="type">
			<div class="title">Classes</div>
			<ul class="list flex">
				<li class="item" v-for="(item,index) in classifyList" :key="index" @click="toDetail(item.id)">
					<div class="picture">
						<img :src="imgBaseUrl+item.image" alt="">
						<div class="tag">
							<div>{{item.name}}</div>
							<div>{{item.age}}</div>
						</div>
					</div>
					<!-- <div class="intro"></div> -->
					<div class="intro">{{item.introduction}}</div>
				</li>
			</ul>
		</div>
		<div class="calendar_box">
			<div class="calendar_main">
				<div class="select_list flex">
					<div class="item flex align-center justify-between">
						<el-select v-model="course_age_id" clearable  placeholder="for any age" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in ageList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="timeStatus" clearable   placeholder="Any time" size="small"  @change="changeTime">
						   <el-option
						     v-for="item in timeOptions"
						     :key="item.value"
						     :label="item.label"
						     :value="item.value">
						   </el-option>
						</el-select>
						
					</div>
					<div class="item flex align-center justify-between">
						<el-select v-model="course_shop_id" clearable  placeholder="Any Venue" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in shopList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="course_type_id" clearable  placeholder="Any class" size="small"  @change="getCourseList">
						   <el-option
						     v-for="item in classifyList"
						     :key="item.id"
						     :label="item.name"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
					<div class="item flex align-center ustify-between">
						<el-select v-model="selectWeek" clearable  placeholder="Any day" size="small"  @change="changeWeek">
						   <el-option
						     v-for="item in selectWeekList"
						     :key="item.id"
						     :label="item.label"
						     :value="item.id">
						   </el-option>
						</el-select>
					</div>
				</div>
				<div class="calendar_header flex align-center justify-between">
					<div class="left flex align-center" @click="lastMonth">
						<img src="../../../assets/images/icon/left.png" alt="">
						<span>Last week</span>
					</div>
					<div class="date">{{showTime1}}-{{showTime2}}</div>
					<div class="right flex align-center" @click="nextMonth">
						<span>Next week </span>
						<img src="../../../assets/images/icon/right.png" alt="">
					</div>
				</div>
				<div class="weeklist">
					<ul class="weekName flex align-center justify-between">
						<li class="item" v-for="(item,index) in weekList" :key="index">
							<span>{{item}}</span>
							<span class="day">{{weekDayList[index]}}</span>
						</li>
					</ul>
					<div class="course_list flex justify-between">
						<div class="day_item" v-for="(item,index) in courseList" :key="index"  >
							<div>
								<div class="item" v-for="(ite,ind) in item.course" :key="ind" @click="openIntro(ite.course_id)">
									<div class="time">{{ite.start_time}} - {{ite.end_time}} </div>
									<div class="place line_two">{{ite.course_shop_name}}</div>
									<div class="info" :style="{'background':ite.color}">
										<div class="name">{{ite.course_type_name}} </div>
										<div class="age">{{ite.course_age_name}}</div>
									</div>
									<div class="tag" v-if="ite.can_num == 0" @click.stop="addWaiting(ite.id)">waiting list</div>
									<div class="tag_list flex align-center" v-else-if="ite.is_try == 1">
										<div class="tag" @click.stop="ensureOrder(ite.course_id,1,ite.id,ite.date_id,ite.combo_num)">Trial</div>
										<div class="tag" @click.stop="ensureOrder(ite.course_id,0,ite.id,ite.date_id,ite.combo_num)">Book Now</div>
									</div>
									<div class="tag" @click.stop="ensureOrder(ite.course_id,0,ite.id,ite.date_id,ite.combo_num)" v-else>Book Now</div>
								</div>
							</div>
							
						</div>
					</div>
				</div>
			</div>
		</div>
		
		<div class="leason_model" v-if="type>0">
			<leason v-if="type == 1" 
			ref="leason"
			:orderDetail="orderDetail" 
			:courseList="secondCourseList"
			:selectAll="selectAll"
			:hasPack="hasPack"
			:combo_num="combo_num"
			@close="close"
			@selectAllCourse="selectAllCourse"
			@selectCourse = 'selectCourse'
			></leason>
			<TryLeason
			v-else-if="type == 2"
			 ref="tryLeason"
			 :orderDetail="orderDetail"
			 :courseList="secondCourseList"
			 :tryPrice="tryPrice"
			 @close="close"
			 @selectTryCourse = 'selectTryCourse'
			></TryLeason>
			<courseIntro :courseIntro="courseIntro" @close="close" @tyrCourse="tyrCourse" v-else></courseIntro>
		</div>
		<div class="model" v-if="leasonStatus">
			<div class="model_content">
				<div class="header">
					<div class="title">Classes</div>
					<img src="../../../assets/images/icon/close.png" alt="" @click="leasonStatus = false ">
				</div>
				<div class="list">
					<div class="item flex align-center justify-between" v-for="(item,index) in classifyDetailList" :key="index" @click="toWeek(item.shop.id)">
						<div class="left">
							<div class="name"><span class="date">{{item.type.name}}</span>   ({{item.start_date}}-{{item.end_date}})</div>
							<div class="address">{{item.shop.name}}</div>
						</div>
						<div class="age">{{item.age.name}}</div>
					</div>
				</div>
			</div>
			
		</div>
		<div class="model" v-if="showSelectChild">
			<div class="select_child_model">
				<div class="header">
					<div class="title">Select Child</div>
					<img src="../../../assets/images/icon/close.png" alt="" @click="showSelectChild = false ">
				</div>
				<div class="parent_info">
					<div class="discount_item flex align-center justify-between">
						<div class="name">Full Name:</div>
						<input type="text" class="val" v-model="full_name" placeholder="Full Name" >
					</div>
					<div class="discount_item flex align-center justify-between">
						<div class="name">Mobile:</div>
						<input type="text" class="val" v-model="contact_number" placeholder="Mobile" >
					</div>
					<div class="discount_item flex align-center justify-between">
						<div class="name">Eamil:</div>
						<input type="text" class="val" v-model="email" placeholder="Email" >
					</div>
				</div>
				<div class="price_bottom flex align-center justify-between">
					<div class="price"></div>
					<div class="btn" @click="ensureWainting">Join Waiting list</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Leason from '/src/components/parentLeason/leason.vue'
	import TryLeason from '/src/components/parentLeason/tryLeason.vue'
	import courseIntro from '/src/components/parentLeason/courseIntro.vue'
	export default{
		components:{
			Leason,
			courseIntro,
			TryLeason
		},
		data(){
			return{
				imgBaseUrl:this.$api.imgBaseUrl,
				pageDetail:{},
				weekList:['Mon','Tue','Wed','Thur','Fri','Sat','Sun'],
				type:-1,
				classifyList:[],
				classifyDetailList:[],
				leasonStatus:false,
				shopList:[],
				ageList:[],
				course_age_id:'',
				course_shop_id:'',
				course_type_id:'',
				start_time:'',
				start_time1:'',
				end_time1:'',
				end_time:'',
				showTime1:'',
				showTime2:'',
				end_date:'',
				start_date:'',       
				weekStartDay:'',     //一周开始事件
				weekDayList:[],     //每周日期列表
				secondCourseList:[],     //日历课程列表
				problemList:[],
				content:'',
				contact:'',
				name:'',
				courseIntro:{},
				orderDetail:{},
				courseList:[],
				childList:[],
				selectAll:false,
				timeStatus:'',
				timeOptions:[{
					value:0,
					label:'AM'
				},{
					value:1,
					label:'PM'
				}],
				selectWeekList:[{id:0,label:'Monday'},{id:1,label:'Tuesday'},{id:2,label:'Wednesday'},{id:3,label:'Thursday'},{id:4,label:'Friday'},{id:5,label:'Saturday'},{id:6,label:'Sunday'}],
				selectWeek:'',
				select_date:'',
				hasPack:0,
				combo_num:0,
				tryPrice:'',
				select_date_index:-1,
				
				selectChildList:[],
				showChildList:false,
				selectChild:0,
				showSelectChild:false,
				waitCourseId:'',
				full_name:'',
				contact_number:'',
				email:''
			}
		},
		created(){
			var date = this.$route.query.date;
			if(date){
				this.getWeek(new Date(date))
			}else{
				this.getWeek(new Date());
			}
			this.getSystem()
			this.getClassify();
			this.getShopList();
			this.getAgeList();
			
			
			this.getChild();
			this.getpack();
		},
		methods:{
			addWaiting(id){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
					return
				};
				this.waitCourseId = id;
				this.showSelectChild = true;
			},
			toAdd(){
				this.$router.push('/home/userInfo/editChild')
			},
			delChild(index){
				console.log(index)
				this.selectChildList.splice(index,1);
			},
			select_child(index){
				this.showChildList = false;
				if(this.selectChildList.length>0){
					this.selectChildList = []
				}
				this.selectChildList.push(this.childList[index]);
			},
			ensureWainting(){
				
				
				var params = {
					course_id:this.waitCourseId,
					full_name:this.full_name,
					contact_number:this.contact_number,
					email:this.email
				}
				this.$api.post('Parents/wait',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
						this.showSelectChild = false
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			closePopover(){
				this.$refs.popover.doClose()
			},
			// 立即订课
			ensureOrder(id,type,course_id,date_id,combo_num){
				var token = localStorage.getItem('token');
				if(!token){
					this.$router.push('/login')
					return
				}
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
						var params = {
							course_id:id,
							date_id:date_id,
							course_product_id:course_id
						}
						if(type == 0){
							if(this.hasPack>combo_num){
								params.combo_num = combo_num
							}else{
								params.combo_num = this.hasPack
							}
						}
						this.$api.post('parents_order/buyNowConfirmOrder',params,res=>{
							if(res.code == 1){
								if(res.data.all_list.length == 0){
									this.$message({
										showClose:true,
										duration:0,
										message:'Coming soon ! Watch this space !'
									})
									return;
								}
								if(type == 1){
									this.type = 2
								}else{
									this.selectAll = false;
									if(this.hasPack>combo_num){
										this.combo_num = combo_num;
									}else{
										this.combo_num = this.hasPack
									}
									this.type = 1;
								}
								var allStatus = true;
								res.data.all_list.forEach((item,index)=>{
									item.start_time = item.start_time.substring(0,5)
									item.end_time = item.end_time.substring(0,5)
									
									if(item.id == course_id){
										item.select = true;
										this.tryPrice = item.try_price
									}else{
										if(item.is_expired){
											if(type == 1){
												if(item.is_try == 0){
													item.is_expired = false;
												}
												
											}
											item.select = false;
											allStatus = false
										}
										
									}
								});
								this.selectAll = allStatus;
								this.secondCourseList = res.data.all_list;
								this.orderDetail = res.data;
							}else if(res.code == 66){
								this.$message({
									showClose:true,
									duration:0,
									message:res.msg
								})
								setTimeout(()=>{
									this.$router.push('/home/userInfo/editChild')
								},500)
								
							}else{
								this.$message({
									showClose:true,
									duration:0,
									message:res.msg
								})
							}
						})
					}
				},err=>{
							if(err.code == '401'){
								localStorage.removeItem('token');
								this.$router.push('/login')
							}
						})
				
			},
			// 预约订课
			tyrCourse(){
				this.type = -1
				console.log(0)
				this.$api.post('Parents/getCourseByType',{course_type_id	:this.courseIntro.course_type_id},res=>{
					if(res.code == 1){
						this.classifyDetailList = res.data;
						this.leasonStatus = true;
					}
				},err=>{
					if(err.code == '401'){
						localStorage.removeItem('token');
						this.$router.push('/login')
					}
				})
			},
			// 选择课程
			toWeek(id){
				this.$router.push({path:'/home/parent/selectCourse',query:{course_type_id:this.courseIntro.course_type_id,course_shop_id:id}})
			},
			// 获取套餐余量
			getpack(){
				this.$api.post('user/getUserDetails',{},res=>{
					if(res.code == 1){
						this.hasPack = res.data.combo_num;
					}
				})
			},
			selectTryCourse(data){
				if(this.secondCourseList[data.index].is_try == 0){
					this.$message({
						showClose:true,
						duration:0,
						message:'Auditions are not supported'
					})
					return
				}
				this.secondCourseList.forEach((item,index)=>{
					item.select = false;
				})
				this.secondCourseList[data.index].select = true;
				this.tryPrice = this.secondCourseList[data.index].try_price;
				this.$forceUpdate()
			},
			// 选择小课
			selectCourse(data){
				this.secondCourseList[data.index].select = !this.secondCourseList[data.index].select;
				var status = false;
				var courseNum = 0;
				this.selectAll = true
				this.secondCourseList.forEach((item,index)=>{
					if(item.is_expired){
						if(!item.select){
							status = true
						}else{
							courseNum += item.combo_num*1
						}
					}
					
				})
				if(status){
					this.selectAll = false
				}
				
				if(this.hasPack > courseNum){
					this.combo_num = courseNum
				}else{
					this.combo_num = this.hasPack
				}
				this.$forceUpdate()
				setTimeout(()=>{
					this.$refs.leason.buyCourse();
				},100)
			},
			selectAllCourse(data){
				this.selectAll = !this.selectAll;
				var courseNum = 0
				this.secondCourseList.forEach((item,index)=>{
					if(this.selectAll){
						if(item.is_expired){
							item.select = true;
							courseNum += item.combo_num*1;
						}
					}else{
						item.select = false
					}
				})
				
				
				if(this.hasPack > courseNum){
					this.combo_num = courseNum
				}else{
					this.combo_num = this.hasPack
				}
				this.$forceUpdate()
				setTimeout(()=>{
					this.$refs.leason.buyCourse();
				},100)
			},
			// 获取孩子列表
			getChild(){
				this.$api.post('user/getChildList',{},res=>{
					if(res.code == 1){
						this.childList = res.data;
					}
				})
			},
			// 打卡课程简介
			openIntro(id){
				this.$api.post('Parents/getCourseIntroduction',{id:id},res=>{
					if(res.code == 1){
						this.type = 3;
						this.courseIntro= res.data;
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			// 关闭弹窗
			close(){
				this.type = -1;
			},
			changeTime(e){
				console.log(e)
				if(this.timeStatus == 0){
					this.start_time = '00:00';
					this.end_time = '12:00'
				}else{
					this.start_time = '12:00';
					this.end_time = '24:00'
				}
				this.getCourseList()
			},
			changeWeek(e){
				var start = this.start_date.substring(this.start_date.length-2);
				this.select_date_index = e;
				if(this.weekDayList[e] > start){
					this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[e]
				}else{
					this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[e]
				}
				this.getCourseList()
			},
			// changeStartTime(e){
			// 	console.log(e)
			// 	var hour = new Date(e).getHours();
			// 	var minutes = new Date(e).getMinutes();
			// 	if(hour < 10){
			// 		hour = '0'+hour
			// 	}
			// 	if(minutes < 10){
			// 		minutes = '0'+minutes
			// 	}
			// 	this.start_time = hour + ':' + minutes;
			// 	console.log(this.start_time)
			// 	this.getCourseList()
			// },
			// changeEndTime(e){
			// 	console.log(e)
			// 	var hour = new Date(e).getHours();
			// 	var minutes = new Date(e).getMinutes();
			// 	if(hour < 10){
			// 		hour = '0'+hour
			// 	}
			// 	if(minutes < 10){
			// 		minutes = '0'+minutes
			// 	}
			// 	this.end_time = hour + ':' + minutes;
			// 	this.getCourseList()
			// },
			getWeek(date){
				var one_day = 86400000;
				var day = date.getDay();
				var weekList = [];
				if(date.getDay()=="0"){
					var week_start_time = date.getTime() - 6 * one_day;
					var week_end_time = date.getTime() ;
				}else {
					var week_start_time = date.getTime() - (day - 1) * one_day;
					var week_end_time = date.getTime() + (7 - day) * one_day;
				}
				
				var month1 = new Date(week_start_time).getMonth()+1;
				var month2 = new Date(week_end_time).getMonth()+1;
				var day1 = new Date(week_start_time).getDate();
				var day2 = new Date(week_end_time).getDate();
				var year1 = new Date(week_start_time).getFullYear();
				var year2 = new Date(week_end_time).getFullYear();
				if(month1<10){
					month1 = "0"+month1;
				}
				if(month2<10){
					month2 = "0"+month2;
				}
				if(day1<10){
					day1 = "0"+day1;
				}
				if(day2<10){
					day2 = "0" + day2;
				}
				weekList.push(day1)
				
				var myDate = date.getDate()
				var date1 = new Date(week_start_time)
				for(var i = 0;i< 6;i++){
					date1.setDate(date1.getDate() + 1);
					myDate = date1.getDate()
					if(date1.getDate()<10){
						myDate= '0'+ myDate;
					}
					weekList.push(myDate);
				}
				this.weekDayList = weekList;
				this.showTime1 = day1+'/'+month1+'/'+year1;
				this.showTime2 = day2+'/'+month2+'/'+year2;
				this.start_date = year1+'-'+month1+'-'+day1;
				this.end_date = year2+'-'+month2+'-'+day2;
				var start = this.start_date.substring(this.start_date.length-2);
				if(this.select_date_index>=0){
					if(this.weekDayList[this.select_date_index] > start){
						this.select_date = this.start_date.substring(0,this.start_date.length-2)+this.weekDayList[this.select_date_index]
					}else{
						this.select_date = this.end_date.substring(0,this.end_date.length-2)+this.weekDayList[this.select_date_index]
					}
				}
				this.getCourseList()
			},
			lastMonth(){
				var date = new Date(this.start_date).getTime();
				date = date - 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			nextMonth(){
				var date = new Date(this.end_date).getTime();
				date = date + 24* 60*60*1000;
				this.getWeek(new Date(date))
			},
			getCourseList(){
				console.log(this.selectWeek)
				var params = {
					start_date:this.start_date,
					end_date:this.end_date,
					start_time:this.start_time,
					end_time:this.end_time,
					course_age_id:this.course_age_id,
					course_type_id:this.course_type_id,
					course_shop_id:this.course_shop_id,
					date:this.select_date
				}
				this.$api.post('Parents/getCourseList',params,res=>{
					if(res.code == 1){
						res.data.forEach((item,index)=>{
							if(item.course.length >0){
								item.course.forEach((ite,ind)=>{
									ite.start_time = ite.start_time.substring(0,5)
									ite.end_time = ite.end_time.substring(0,5)
								})
							}
							
						})
						this.courseList = res.data;
					}
				})
			},
			getClassify(){
				this.$api.post('Parents/getCourseType',{},res=>{
					if(res.code == 1){
						this.classifyList = res.data;
					}
				})
			},
			getShopList(){
				this.$api.post('Parents/getCourseShop',{},res=>{
					if(res.code == 1){
						this.shopList = res.data;
					}
				})
			},
			getAgeList(){
				this.$api.post('Parents/getCourseAge',{},res=>{
					if(res.code == 1){
						this.ageList = res.data;
					}
				})
			},
			feedback(){
				var params = {
					content:this.content,
					contact:this.contact,
					name:this.name
				}
				this.$api.post('common/feedback',params,res=>{
					if(res.code == 1){
						this.$message({
							showClose:true,
							duration:0,
							message:'Successful'
						})
					}else{
						this.$message({
							showClose:true,
							duration:0,
							message:res.msg
						})
					}
				})
			},
			
			getSystem(){
				this.$api.post('common/getsystem',{type:'parents'},res=>{
					if(res.code == 1){
						res.data.parents_ads = res.data.parents_ads.split(',')
						this.pageDetail = res.data;
					}
				})
			},
			toDetail(id){
				this.$router.push({path:'/home/parent/detail',query:{id:id}})
			}
		}
	}
</script>
<style lang="scss">
	.el-popover{
		padding: 0!important;
	}
</style>

<style lang="scss" scoped>
	::v-deep .el-popover{
		padding: 0!important;
	}
	.banner{
		width: 100%;
		height: 574px;
		
		img{
			width: 100%;
			height: 100%;
		}
		::v-deep .el-carousel__indicators--horizontal{
			display: block;
			
		}
		::v-deep .el-carousel__indicator--horizontal button{
			display: block;
			width: 8px;
			height: 8px;
			background: #FFFFFF;
			opacity: 0.3;
			border-radius: 50%;
			padding: 0 ;
			margin-right: 30px;
		}
		::v-deep .el-carousel__indicator--horizontal.is-active button{
			opacity: 1;
		}	
	}
	.intro_box{
		width: 1200px;
		margin: 40px auto;
		// background: url('../../../assets/images/icon/logo.png') no-repeat;
		.title{
			font-size: 20px;
			font-weight: bold;
			color: #282E30;
			text-align: center;
		}
		.info{
			font-size: 18px;
			font-weight: 400;
			color: #282E30;
			line-height: 30px;
			margin-top: 40px;
			
		}
	}
	.type{
		width: 1200px;
		margin: 40px auto;
		.title{
			font-size: 20px;
			font-family: Source Han Sans CN;
			font-weight: bold;
			color: #282E30;
		}
		.list{
			margin-top: 40px;
			flex-wrap: wrap;
			.item{
				width: 290px;
				margin-right: 13px;
				margin-bottom: 30px;
				cursor: pointer;
				&:nth-child(4n+0){
					margin-right: 0;
				}
				.picture{
					width: 100%;
					height: 260px;
					overflow: hidden;
					position: relative;
				}
				img{
					width: 100%;
					height: 100%;
				}
				.tag{
					width: 100%;
					height: 90px;
					background-color: rgba(255,255,255,0.8);
					position: absolute;
					left: 0;
					bottom: 0;
					line-height: 30px;
					text-align: center;
					font-size: 16px;
					font-family: Source Han Sans CN;
					font-weight: bold;
					color: #BF5F49;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					div{
						text-align: center;
					}
				}
				.intro{
					padding-top: 10px;
					font-size: 20px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					line-height: 30px;
				}
			}
		}
	}
	.calendar_box{
		width: 100%;
		background: #5C707A;
		padding-bottom: 40px;
		.calendar_main{
			width: 1200px;
			margin: 0 auto;
			padding-top: 40px;
			.select_list{
				.item{
					// padding: 0 20px;
					height: 60px;
					background: #FFFFFF;
					border-radius: 10px;
					margin-right: 40px;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					img{
						width: 27px;
						height: 15px;
						margin-left: 10px;
					}
				}
			}
			::v-deep .el-select-dropdown__list{
				padding: 15px 0;
			}
			::v-deep .el-select{
				// width: 100%;
				height: 100%;
			}
			::v-deep .el-input.el-input--suffix{
				height: 100%;
			}
			::v-deep .el-input__icon{
				line-height: 56px;
			}
			::v-deep .el-input--suffix .el-input__inner{
				height: 100%;
				font-size: 18px;
				background-color: #F7F2EB;
				border: none;
				color: #282E30;
			}
			::v-deep .el-time-spinner__item{
				text-align: center;
			}
			.calendar_header{
				margin-top: 30px;
				font-size: 20px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				img{
					width: 25px;
					height: 26px;
				}
				.left{
					cursor: pointer;
					span{
						margin-left: 10px;
					}
				}
				.right{
					cursor: pointer;
					span{
						margin-right: 10px;
					}
				}
			}
			.weeklist{
				margin-top: 30px;
				.weekName{
					.item{
						width: 150px;
						height: 60px;
						border: 1px solid #FFFFFF;
						border-radius: 10px;
						padding-left: 30px;
						font-size: 20px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #FFFFFF;
						line-height: 60px;
						.day{
							margin-left: 15px;
						}
					}
				}
				.course_list{
					margin-top: 20px;
					.day_item{
						width: 150px;
						.item{
							width: 100%;
							height: 220px;
							padding-top: 5px;
							background: #FFFFFF;
							font-size: 16px;
							font-family: Source Han Sans CN;
							font-weight: 400;
							color: #282E30;
							line-height: 30px;
							text-align: center;
							border-radius: 10px;
							overflow: hidden;
							margin-bottom: 20px;
							cursor: pointer;
							.time{
								text-align: center;
							}
							.place{
								text-align: center;
								height: 60px;
							}
							.info{
								height: 80px;
								background: #C98B2C;
								line-height: 26px;
								text-align: center;
								font-size: 14px;
								.name{
									text-align: center;
									height: 50px;
									line-height: 25px;
									// overflow: hidden;
									// text-overflow: ellipsis;
									// white-space: nowrap;
								}
								.age{
									font-size: 12px;
									text-align: center;
								}
								&.red{
									background: #BF5F49;
								}
							}
							.tag{
								width: 70px;
								height: 26px;
								border: 1px solid #000000;
								border-radius: 13px;
								font-size: 12px;
								font-family: Source Han Sans CN;
								font-weight: 400;
								color: #000000;
								text-align: center;
								line-height: 26px;
								margin: 7px auto 0;
								cursor: pointer;
							}
						}
					}
				}
			}
		}
	}
	.kefu{
		position: fixed;
		right: 30px;
		bottom: 50%;
		z-index: 999;
		img{
			width: 100px;
			height: 100px;
		}
		
	}
	::v-deep .el-popover{
		padding: 0;
	}
	.kefu_content{
		width: 750px;
		height: 800px;
		overflow-y: scroll;
		.header{
			width: 100%;
			height: 88px;
			background: #5C707A;
			border-radius: 10px;
			position: relative;
			.title{
				font-size: 30px;
				font-family: Source Han Sans CN;
				font-weight: 500;
				color: #FFFFFF;
				text-align: center;
				line-height: 88px;
			}
			.close{
				width: 29px;
				height: 28px;
				position: absolute;
				right: 30px;
				top: 50%;
				transform: translateY(-50%);
			}
		}
		.problem_content{
			width: 100%;
			padding: 30px 30px 50px;
			background: #F7F2EB;
			.photo{
				width: 79px;
				height: 79px;
				border-radius: 50%;
				overflow: hidden;
				margin-right: 20px;
				img{
					width: 100%;
					height: 100%;
				}
			}
			.list{
				width: 492px;
				background: #F7F2EB;
				box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
				border-radius: 0px 20px 20px 20px;
				padding: 0 30px 30px;
				.item{
					width: 100%;
					height: 67px;
					line-height: 67px;
					font-size: 24px;
					font-family: PingFang SC;
					font-weight: 400;
					color: #282E30;
					border-bottom: 1px solid rgba(40,46,48,0.2);
					&.weight{
						font-size: 26px;
						font-weight: bold;
						color: #282E30;
					}
					img{
						width: 15px;
						height: 27px;
					}
				}
			}
			
		}
		.fileInfo_box{
			width: 100%;
			background: #F7F2EB;
			box-shadow: 0px -17px 18px 0px rgba(35,24,21,0.0400);
			border-radius: 10px;
			padding: 50px 30px;
			.info_item{
				margin-bottom: 30px;
				input{
					width: 100%;
					height: 80px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 0 30px;
					line-height: 80px;
					font-size: 24px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 80px;
				}
				textarea{
					width: 100%;
					height: 200px;
					background: #F7F2EB;
					border: 1px solid #CCCCCC;
					border-radius: 20px;
					padding: 27px 30px;
					font-size: 24px;
					font-family: PingFangSC;
					font-weight: 500;
					color: #999999;
					line-height: 30px;
					outline: none;
				}
			}
		}
		.submit{
			width: 500px;
			height: 88px;
			background: #5C707A;
			box-shadow: 0px 2px 7px 0px rgba(0,0,0,0.2000);
			border-radius: 20px;
			margin:0 auto;
			font-size: 30px;
			font-family: PingFang SC;
			font-weight: bold;
			color: #F7F2EB;
			line-height: 88px;
			text-align: center;
			cursor: pointer;
		}
	}
	.leason_model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background-color: rgba(0,0,0,0.2);
		z-index: 99;
	}
	.model{
		position: fixed;
		top: 0;
		left: 0;
		bottom: 0;
		right: 0;
		background: rgba(0,0,0,0.2);
		z-index: 99;
		.model_content{
			width: 750px;
			height: 600px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 0 30px;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			.list{
				padding: 40px 0;
				.item{
					width: 100%;
					height: 140px;
					background: #F7F2EB;
					box-shadow: 0px 8px 16px 0px rgba(92,112,122,0.3000);
					border-radius: 10px;
					padding: 25px 20px 20px 40px;
					margin-bottom: 20px;
					
					.name{
						font-size: 24px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
						line-height: 30px;
						span{
							margin-right: 20px;
						}
					}
					.address{
						margin-top: 15px;
						font-size: 24px;
						font-family: Source Han Sans CN;
						font-weight: bold;
						color: #282E30;
					}
					.age{
						font-size: 24px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #282E30;
					}
				}
			}
		}
		.select_child_model{
			width: 750px;
			height: 380px;
			overflow-y: scroll;
			background: #F7F2EB;
			box-shadow: 0px 5px 20px 0px rgba(0,0,0,0.2000);
			border-radius: 10px;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%,-50%);
			padding: 0 30px;
			.header{
				width: 100%;
				height: 88px;
				border-bottom: 1px solid #5C707A;
				position: relative;
				.title{
					font-size: 30px;
					font-family: Source Han Sans CN;
					font-weight: 500;
					color: #282E30;
					text-align: center;
					line-height: 88px;
				}
				img{
					width: 29px;
					height: 28px;
					position: absolute;
					right: 0;
					top: 50%;
					transform: translateY(-50%);
				}
			}
			
			.discount_item{
				width: 100%;
				height: 62px;
				border-bottom: 1px solid #5C707A;
				padding: 0 30px 0 15px;
				.name{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
				}
				.val{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #BF5F49;
					text-align: right;
				}
				.item_btn{
					width: 110px;
					height: 30px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 30px;
					text-align: center;
					font-size: 18px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin-left: 10px;
					cursor: pointer;
				}
			}
			.price_bottom{
				margin-top: 30px;
				.price{
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #282E30;
					span{
						color: #BF5F49;
					}
				}
				.btn{
					width: 200px;
					height: 58px;
					background: #5C707A;
					border-radius: 29px;
					line-height: 58px;
					text-align: center;
					font-size: 22px;
					font-family: Source Han Sans CN;
					font-weight: 400;
					color: #F7F2EB;
					margin-left: 10px;
					cursor: pointer;
				}
			}
		}
	}
</style>